import React from 'react';
import { Text } from '@simplybenefits/sb-ui-library';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { 
    Add as AddIcon, 
    Remove as RemoveIcon 
} from '@mui/icons-material';

/**
 *
 * @param {*} props
 */
export default function VirtualHealthcare({ classes, expanded, virtualHealthcare, handleChange, accessCode }) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('virtualHealthcare')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    sx={classes.accordionSummary}
                    expandIcon={expanded.includes('virtualHealthcare') ? <RemoveIcon /> : <AddIcon />}
                >
                    <Text medium bold>Virtual Healthcare</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        virtualHealthcare.isEligible === 1 ?
                            <React.Fragment>
                                {
                                    virtualHealthcare.includeMaple === 1 &&
                                        <>
                                            <Text small bold margin="20px 0px 10px 0px">
                                                {`Virtual Healthcare (Maple) connects you to a clinician 24/7 for all your urgent and long term healthcare needs, via phone and video chat. Save time and stress when you need convenient access to:`}
                                            </Text>
                                            <ul style={{ listStyle: 'disc', paddingLeft: '16px', margin: '0px' }}>
                                                <li><Text small margin="0px 0px 5px 0px">Medical diagnosis.</Text></li>
                                                <li><Text small margin="0px 0px 5px 0px">Prescriptions and requisitions.</Text></li>
                                                <li><Text small margin="0px 0px 5px 0px">Specialist referrals.</Text></li>
                                                <li><Text small margin="0px 0px 5px 0px">Mental health support.</Text></li>
                                                <li><Text small margin="0px 0px 5px 0px">Chronic illness management and prevention.</Text></li>
                                                <li><Text small margin="0px 0px 5px 0px">Health coaching and advice.</Text></li>
                                            </ul>
                                            <Text small margin="10px 0px 0px 0px">
                                                Register today at <a href="http://getmaple.ca/simply-benefits" target="_blank" rel="noopener noreferrer">getmaple.ca/simplybenefits</a>
                                            </Text>
                                        </>
                                }
                                
                                {
                                    virtualHealthcare.includeGotodoctor === 1 &&
                                        <>
                                            <Text small bold margin="20px 0px 10px 0px">
                                                {`Gotodoctor.ca gives you the ability to skip waiting in a walk-in clinic and see the doctor from home, work or a virtual clinic location. This convenient way to get the prescriptions, referrals, and requisitions you might need, also allows you to pick up the prescription at your preferred pharmacy or have it delivered.`}
                                            </Text>
                                            <Text small margin="20px 0px 10px 0px">
                                                {`With gotodoctor.ca you will have:`}
                                            </Text>
                                            <ul style={{ listStyle: 'disc', paddingLeft: '16px', margin: '0px' }}>
                                                <li><Text small margin="0px 0px 5px 0px">Access to licensed Canadian physicians via telephone or video chat.</Text></li>
                                                <li><Text small margin="0px 0px 5px 0px">Additional access to on-site diagnostic testing and physical assessments at in-pharmacy clinics.</Text></li>
                                                <li><Text small margin="0px 0px 5px 0px">Continuity of care with the same physician team, even when traveling outside the province.</Text></li>
                                                <li><Text small margin="0px 0px 5px 0px">Dedicated portal and support staff to coordinate care for you and your family members.</Text></li>
                                                <li><Text small margin="0px 0px 5px 0px">Prescription and product discount at available network pharmacies.</Text></li>
                                            </ul>
                                            <Text small margin="10px 0px 0px 0px">
                                                Book today at <a href="http://gotodoctor.ca/simplybenefits" target="_blank" rel="noopener noreferrer">gotodoctor.ca/simplybenefits</a>.
                                            </Text>
                                        </>
                                }

                                {
                                    virtualHealthcare.includeDialogue === 1 &&
                                        <>
                                            <Text small bold margin="20px 0px 10px 0px">
                                                {`Virtual Healthcare (Dialogue) provides you with real-time access via chat, phone or video to a multidisciplinary medical team to help treat non-urgent health concerns.`}
                                            </Text>
                                            <ul style={{ listStyle: 'disc', paddingLeft: '16px', margin: '0px'}}>
                                                <li><Text small margin="0px 0px 5px 0px"> Unlimited virtual medical care 24/7.</Text></li>
                                                <li><Text small margin="0px 0px 5px 0px"> Video-based medical consultations.</Text></li>
                                                <li><Text small margin="0px 0px 5px 0px"> Support for a wide variety of issues.</Text></li>
                                                <li><Text small margin="0px 0px 5px 0px"> Personalized follow-ups after every consultation.</Text></li>
                                                <li><Text small margin="0px 0px 5px 0px"> Consultations with other allied health professionals for an additional fee that may be covered by your insurance.</Text></li>
                                            </ul>
                                            <Text small margin="10px 0px 0px 0px">
                                                Register today at <a href="https://pages-support.dialogue.co/signup/" target="_blank" rel="noopener noreferrer">dialogue.co/signup</a>.
                                            </Text>
                                        </>
                                }

                                {
                                    virtualHealthcare.includeKii ?
                                        <>
                                            <Text small bold margin="20px 0px 10px 0px">
                                                Welcome to Kii, a program designed to empower you to live your best life. Services are delivered via chat messaging, phone or video using CloudMD’s proprietary, telemedicine platform accessed via Kii.
                                            </Text>
                                            <ul style={{ listStyle: 'disc', paddingLeft: '16px', margin: '0px' }}>
                                                <li><Text small margin="0px 0px 5px 0px"> General Medical Advice - Cold and flu symptoms, rash, headaches, eye pain, allergic reactions, joint pain, back pain, asthma exacerbation, covid exposure, women’s health, sexual health, child and infant care.</Text></li>
                                                <li><Text small margin="0px 0px 5px 0px"> Diet, Nutrition and Lifestyle Concerns - Nutrition advice, sleep support, exercise, substance and alcohol use.</Text></li>
                                                <li><Text small margin="0px 0px 5px 0px"> New and Refill Prescriptions - Avoid the back and forth with pharmacies and doctors and get your prescription easily and quickly.</Text></li>
                                                <li><Text small margin="0px 0px 5px 0px"> Sick Notes, Lab work Requests and Lab Results - Get a sick note, requests for lab work such as blood tests and review your results with a clinician.</Text></li>
                                                <li><Text small margin="0px 0px 5px 0px"> Referrals for Specialists - Whether you don’t have a family doctor or are looking for a trusted referral to a healthcare specialist we have a directory of over 20,000+ specialists in the country that we can connect you with.</Text></li>
                                            </ul>
                                            <Text small margin="10px 0px 0px 0px">
                                                There is no cost to you or your family to use Kii. This program has been provided to you by your employer.
                                            </Text>

                                            <a href="https://secure.kiihealth.ca/register?eac=&lang=en" style={{ textDecoration: 'none', textDecoration: 'underline' }} target="_blank" rel="noopener noreferrer">
                                                <Text
                                                    small
                                                    display="block"
                                                    margin="5px 0px 0px 0px"
                                                >
                                                    Register with Kii
                                                </Text>
                                            </a>
                                        </>
                                        : null
                                }

                                {
                                    accessCode ?
                                        <Text small margin="10px 0px 0px 0px">
                                            Access Code: { accessCode }
                                        </Text>
                                        : null
                                }
                            </React.Fragment>
                            :
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                You are currently ineligible for this benefit, if this is a mistake please contact your administrator.
                                </Text>
                            </div>
                    }
                </AccordionDetails>
            </Accordion>
        </div>
    );
}